// extracted by mini-css-extract-plugin
export default {"note":"src-views-publisherStoryEditor-containers-LockUnlockLiveStoryAlert-LockUnlockLiveStoryAlert__note--DDtb_"};